import dayjs from 'dayjs';
import subscribers from '@/store/modules/csv/subscribers';
import supporters from '@/store/modules/csv/supporters';
import claimers from '@/store/modules/csv/claimers';
import contacts from '@/store/modules/csv/contacts';

export default {
  namespaced: true,
  modules: {
    subscribers,
    supporters,
    claimers,
    contacts,
  },
  actions: {
    downloadCSV(ctx, { csv, filename }) {
      const formattedFilename = `tryb_${filename}_${dayjs().format('YYYY-MM-DD')}.csv`;
      const anchorEl = document.createElement('a');

      anchorEl.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(csv)}`);
      anchorEl.setAttribute('download', formattedFilename);
      anchorEl.click();
    },
  },
};
